module.exports = __webpack_public_path__ + "static/tetleys-invest-yutongs-sm-ecb1604ef0d9bda4c9e151f6e6421282.jpg";